import Modal from "@/components/Modal/Modal";
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form";
import { useAppDispatch } from "@/store/hooks";
import { getInactiveUsers, getManagers, getMyTeamGCDetail } from "@/store/slices/teamSlice";
import { useSelector } from "react-redux";
import FormControl from "@/components/FormControl/FormControl";
import dayjs from "dayjs";
import toast from "@/lib/toast";
import locationReportService from "@/services/api/locationReport";
import { saveAsExcelFile } from "@/services/excelService/excelSevice";
import { dateFormatter } from "@/components/DateFormat/DateFormat";

interface LocationReportProps {
    openReportModal: boolean;
    setOpenReportModal: () => void;
}

type LocationFormValues = {
    users: any[];
    managers: any[];
    inActiveUserCheckBox?: boolean;
    inActiveUser?: any[];
    ToDate?: string | null;
    FromDate?: string | null;
}

const LocationReport: React.FC<LocationReportProps> = ({ openReportModal, setOpenReportModal }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isEmailLoading, setIsEmailLoading] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    const { teams, managers, inActiveUser } = useSelector(
        (state: any) => state.team
    );
    const { control, watch, reset,setValue, handleSubmit } = useForm<LocationFormValues>({
        defaultValues: {
            users: [],
            managers: [],
            inActiveUser: [],
            inActiveUserCheckBox: false,
            FromDate: null,
            ToDate: null,
        },
    });
    const isInactiveChecked = watch("inActiveUserCheckBox");

    const onSubmit =
        (action: "download" | "email") =>
            async (formData: LocationFormValues) => {
                try {
                    const {
                        FromDate,
                        ToDate,
                        users,
                        managers,
                        inActiveUserCheckBox,
                        inActiveUser,
                    } = formData;

                    const params = {
                        endDate: dateFormatter(ToDate, "MM-dd-yyyy"),
                        startDate: dateFormatter(FromDate, "MM-dd-yyyy"),
                        reportDate: dateFormatter(ToDate, "MM-dd-yyyy"),

                        isCustom: 1,
                        userId: 0,

                        userIds: (users || []).map(u => u.UserId).join(","),
                        managerIds: (managers || []).map(m => m.Id).join(","),

                        IsSendToMail: action === "email",
                        UserStatus: !inActiveUserCheckBox,

                        DeactiveUserIds: inActiveUserCheckBox
                            ? (inActiveUser || []).map(u => u.UserId).join(",")
                            : "",

                        IncludeAllUsers: false,
                    };
                    if (action === "download") {
                        setIsLoading(true);
                        await locationReportService.exportLocationReport(params);
                        toast.success("File downloaded successfully");
                    }
                    if (action === "email") {
                        setIsEmailLoading(true);    
                        const res:any = await locationReportService.sendMailLocationReport(params);
                        if(res === "Success"){
                            toast.success("Email sent successfully");
                        }
                    }
                    
                } catch (error) {
                    toast.error("Something went wrong");
                } finally {
                    setIsLoading(false);
                    setIsEmailLoading(false);
                    setOpenReportModal();
                }
            };

    const handleDownload = handleSubmit(onSubmit("download"));
    const handleSendEmail = handleSubmit(onSubmit("email"));

    useEffect(() => {
        if (teams?.Members?.length && managers?.length && inActiveUser?.length) {
            reset({
                users: teams.Members,
                managers: managers,
                inActiveUser: inActiveUser,

            });
        }

    }, [teams?.Members, managers, inActiveUser, reset, setOpenReportModal]);

    useEffect(() => {
        if (!openReportModal) return;
        dispatch(getMyTeamGCDetail({ from: 1, to: -1, text: "", Status: "all" }));
        dispatch(getInactiveUsers());
        dispatch(getManagers());
        setValue("FromDate", dayjs().startOf("month").toISOString());
        setValue("ToDate", dayjs().toISOString());
    }, [openReportModal, dispatch])

    return (
        <Modal
            modalOpen={openReportModal}
            closeModal={setOpenReportModal}
            heading="Location Report"
            saveButtonText="Download"
            isSendEmail={true}
            onSave={handleDownload}
            SendEmail={handleSendEmail}
            isLoading={isLoading}
            isEmailLoading={isEmailLoading}
        >
            <div className="grid grid-cols-2 gap-x-6 gap-y-15">
                <FormControl
                    control={control}
                    controlType="date"
                    label="From Date"
                    name="FromDate"
                    maxDate={dayjs()}
                />
                <FormControl
                    control={control}
                    controlType="date"
                    label="To Date"
                    name="ToDate"
                    maxDate={dayjs()}
                />

                <FormControl
                    control={control}
                    controlType="select"
                    name="users"
                    label="Select Users"
                    options={teams?.Members || []}
                    idKey="UserId"
                    nameKey="UserName"
                    isMulti
                    returnObject
                    isSelectAll={true}
                    
                />

                <FormControl
                    control={control}
                    controlType="select"
                    name="managers"
                    label="Select Managers"
                    options={managers}
                    idKey="Id"
                    nameKey="Name"
                    isMulti
                    returnObject
                    isSelectAll={true}

                />

                <FormControl
                    controlType="checkbox"
                    name="inActiveUserCheckBox"
                    label="Inactive Users"
                    control={control}
                />

              
                {isInactiveChecked && (
                    <FormControl
                        control={control}
                        controlType="select"
                        name="inActiveUser"
                        label="Select Inactive Users"
                        options={inActiveUser}
                        idKey="UserId"
                        nameKey="UserName"
                        isMulti
                        returnObject
                        isSelectAll={true}
                    />
                )}
            </div>
        </Modal >
    )
}
export default LocationReport


